e.L.icons = {
	folder_id : {},

	init : function(){
		var $icon_wrap = $( '.toggle-icon-wrap' );

		if( $icon_wrap.length > 0 ){
			_.bindAll( this, '_init_add_handlers', '_link_add', '_media_add', '_pdf_add' );
			$icon_wrap.unbind( 'click' ).click( function(){
				$( '#library-main' ).find( '.icon-wrap' ).toggle();
			} );

			if( typeof( $_GET['folder'] ) !== 'undefined' ){
				this.folder_id = $_GET['folder'];
				this._init_add_handlers();
			}
		}
	},

	/**
	 * Take over the handling of the adding
	 * items to single folder from the icons
	 *
	 * @private
	 */
	_init_add_handlers : function(){
		//hi-jack the global.js and dashboard/library.js way of handling the returned values
		EdSpireDashboardObj.addLink.add	    = this._link_add;
		EdSpireDashboardObj.mediaUpload.add	= this._media_add;
		EdSpireDashboardObj.pdfUpload.add	= this._pdf_add;
	},


	_link_add : function( ignore_me, title, url, post_id ){
		var data   = {
			post_id   : post_id,
			title     : title,
			url       : url,
			folder_id : this.folder_id
		};

		EdSpireAjax.Request( 'EdSpireDashboard', 'ajax_add_link', data, function( id ){
			location.reload();
		});

	},

	_media_add : function( ignore_me, id, title, attachment ){
		var data = {
			post_id : attachment.id,
			folder_id : this.folder_id
		};

		EdSpireAjax.Request( 'EdSpireLibrary', 'ajax_add_item_to_folder', data, function( id ){
			location.reload();
		});
	},

	_pdf_add : function( ignore_me, id, title, attachment ){
		var data = {
			post_id : attachment.id,
			folder_id : this.folder_id
		};

		EdSpireAjax.Request( 'EdSpireLibrary', 'ajax_add_item_to_folder', data, function( id ){
			location.reload();
		});
	}
};